import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import StageGroupService from '@forwardflow/services/StageMapping'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export function useGetFubSources(queryParams: PaginationQueryParams) {
   const response = useSWR([QUERY_KEYS.GET_FUB_LEADS, { ...queryParams }], () =>
      StageGroupService.getFubSources(queryParams)
   )
   return {
      ...response,
   }
}
